import paModelExtension from 'conditional?if=quoteandbind_lob&equals=pa!edge/quoteandbind/pa/directives/PaOfferingSelection/defaultQuoteView/modelExtension/MultipleOfferingViewModelExtension';
import hoModelExtension from 'conditional?if=quoteandbind_lob&equals=ho!edge/quoteandbind/ho/directives/HoOfferingSelection/defaultQuoteView/modelExtension/MultipleOfferingViewModelExtension';
import paCoverageHelper from 'conditional?if=quoteandbind_lob&equals=pa!edge/quoteandbind/pa/directives/PaOfferingSelection/defaultQuoteView/util/PaCoveragesTransformationHelper';
import hoCoverageHelper from 'conditional?if=quoteandbind_lob&equals=ho!edge/quoteandbind/ho/directives/HoOfferingSelection/util/HoCoveragesTransformationHelper';

function getLobExtension(lobCode) {
    if (lobCode === 'personalAuto') {
        return paModelExtension;
    } else if (lobCode === 'homeowners') {
        return hoModelExtension;
    }
}

function getCoverageHelperConstructor(lobCode) {
    if (lobCode === 'personalAuto') {
        return paCoverageHelper;
    } else if (lobCode === 'homeowners') {
        return hoCoverageHelper;
    }
}

export default {
    getLobExtension: getLobExtension,
    getCoverageHelperConstructor: getCoverageHelperConstructor
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/integration/quoteandbind/directives/LobOfferingSelection/util/LobOfferingHelper.js
// module id = 329
// module chunks = 0